import { Component, computed, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { InsightsCardComponent, InsightsComponent } from '@core/impact-tracker-ui';
import { TELLENT_SUITE_ENABLED } from '@core/tellent-types';
import { IconComponent } from '@core/user-interface-legacy';

import { ImpactTrackerAnalytics } from '../impact-tracker.analytics';
import { ImpactTrackerService } from '../impact-tracker.service';

@Component({
  selector: 'tlc-impact-tracker-insights-dropdown',
  templateUrl: './impact-tracker-insights-dropdown.component.html',
  styleUrl: './impact-tracker-insights-dropdown.component.less',
  imports: [InsightsComponent, InsightsCardComponent, IconComponent, TranslatePipe],
})
export class ImpactTrackerInsightsDropdownComponent {
  private readonly tellentSuiteEnabled = inject(TELLENT_SUITE_ENABLED);
  protected readonly impactTrackerService = inject(ImpactTrackerService);
  protected readonly impactTrackerAnalytics = inject(ImpactTrackerAnalytics);

  protected cards = computed(() =>
    this.impactTrackerService.cards()?.filter((_, index) => index <= 2),
  );

  protected isVisible = computed(
    () => this.impactTrackerService.data()?.showMenuBanner && this.tellentSuiteEnabled,
  );

  public ngOnInit(): void {
    this.impactTrackerService.fetchData();
  }

  protected openDialog(): void {
    this.impactTrackerAnalytics.trackDialogTriggered('dropdown');
    this.impactTrackerService.openDialog();
  }
}
